var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "c-controls__group" }, [
      _c("label", { staticClass: "c-controls__label" }, [
        _vm._v(_vm._s(_vm.scenarioTitle))
      ]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.scenario,
              expression: "scenario"
            }
          ],
          on: {
            change: [
              function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.scenario = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
              _vm.chooseScenario
            ]
          }
        },
        _vm._l(_vm.scenarios, function(scenario) {
          return _c(
            "option",
            { key: scenario.title, domProps: { value: scenario.title } },
            [_vm._v("\n\t\t\t\t\t" + _vm._s(scenario.title) + "\n\t\t\t\t")]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }